import { canShowContent, isMobile, menuIsBlockingContent, useMenuStore } from "@/stores/MenuStore";
import { LucideMenu } from "lucide-react";

interface DefaultLayoutProps {
  children: React.ReactNode;
  hideMenu: boolean;
}

export default function DefaultLayout({ children, hideMenu }: DefaultLayoutProps) {
  const menuStore = useMenuStore((state) => state);
  let marginLeft = hideMenu ? '0' :
    (isMobile() ? '100vw' : '288px')
    ;

  if (!menuStore.menuOpened) {
    marginLeft = '0px';
  }

  let paddingCls = isMobile() ? 'px-1 pt-16' : 'px-12 pt-12';


  return (
    <>
      {!menuIsBlockingContent() && isMobile() && <div className="fixed top-0 left-0 z-50 w-full h-15 bg-background">
        <div className="flex justify-between gap-2 px-2 cursor-pointer pb-2 border-b-1 border-default-100"  >
          <LucideMenu className="ms-5 mt-3" size={36} onClick={() => menuStore.setMenuOpened(!menuStore.menuOpened)} />
          <div className="flex items-center mt-2 me-8">
            <span className="text-small font-bold uppercase text-default-500 hover:text-default-100 transition-colors me-3">Craque Stats</span>
          </div>
        </div>
      </div>}
      <div className={"relative mx-auto flex flex-col h-screen  " + paddingCls} style={{ marginLeft: marginLeft, display: canShowContent() ? '' : 'none' }}>
        {children}
        <footer className="w-full flex items-center justify-center py-3">
        </footer>
      </div>
    </>
  );
}
